import { HttpService } from "@/core";
import {
  RepoListResp,
  RepoCreateInfoReq,
  RepoDetailResp,
  RepoSimpleListResp,
} from "./repo.interface";

export default class RepoService {
  //
  static usePageListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/repertoty/page",
        params,
      });

    return HttpService.usePagination<RepoListResp>(api);
  }

  static useCreateApi() {
    const api = (data: RepoCreateInfoReq) =>
      HttpService.axios({
        method: "POST",
        url: "/repertoty",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: number, data: RepoCreateInfoReq) => {
      return HttpService.axios({
        method: "PUT",
        url: `/repertoty/${id}`,
        data,
      });
    };
    return HttpService.useRequest<void>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `repertoty/${id}`,
      });
    return HttpService.useRequest<RepoDetailResp>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `repertoty/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }

  static useSimpleListApi() {
    const api = () =>
      HttpService.axios({
        method: "GET",
        url: "repertoty/simple/list",
      });
    return HttpService.usePagination<RepoSimpleListResp>(api);
  }
}
